import { Mixins, Component, Prop } from 'vue-property-decorator'
import MixinInterface from '@/_mixins/index'

import DialogTemplate from '@/_components/dialog/template/template.vue'
import UserAvatar from '@/_components/avatar/user/user.vue'
import LogAuthorization from '@/views/Authorization/components/logAuthorization/logAuthorization.vue'
import Permissions from '@/views/Authorization/components/permissions/permissions.vue'

import ProjectUser from '@/views/Authorization/models/projectUser'
import Log from '@/views/Log/models/log'

@Component({
    inheritAttrs: false,
    name: 'UserInfo',
    components: { DialogTemplate, UserAvatar, Permissions, LogAuthorization },
})
export default class UserLog extends Mixins<MixinInterface>() {
    @Prop({ required: true }) props!: any

    get user(): any {
        return this.props.user
    }

    get projectName() {
        return this.currentProject ? this.currentProjectName : this.props.project.name
    }

    get projectId() {
        return this.currentProject
            ? this.currentProjectId
            : this.props.project._id
            ? this.props.project._id
            : this.props.project.id
    }

    // INFINITELOADING can only be added when view is mounted
    logs: Array<Log> = []
    timeStamp: string | null = new Date().toISOString()
    loading = false

    isMounted = false

    mounted() {
        this.isMounted = true
    }

    async getLogs($state: any) {
        if (this.projectId) {
            try {
                let res: Array<Log> = this.user._id
                    ? await this.user.getProjectUserLog(this.projectId, this.timeStamp)
                    : await ProjectUser.getProjectUserLog(
                          this.user.id,
                          this.projectId,
                          this.timeStamp
                      )

                this.logs = [...this.logs, ...res]

                if (res.length == Log.limit) {
                    let lastElement = res?.pop()
                    this.timeStamp = lastElement ? lastElement?.['time'] : null
                    $state.loaded()
                } else {
                    this.timeStamp = null
                    if (this.logs.length > 0) {
                        $state.loaded()
                    }
                    $state.complete()
                }
            } catch (error) {
                $state.complete()
            }
        }
    }
}
